// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"39":"help","231":"vaccination","443":"about","497":"config","842":"map"}[chunkId] + "." + {"39":"c0343bf6","231":"6e5fc0c6","443":"55754f51","497":"aac7e5d5","842":"9210f93a"}[chunkId] + ".js";
};